/**
 * Firms API — SuperAdmin firm list for onboarding firm picker.
 */

import apiClient from './client';

export interface Firm {
  firm_id: number;
  name: string;
}

const KB_BASE = '/v1/insight/admin/kb';

/**
 * Fetch list of active firms. SuperAdmin (ADMIN permission) only.
 */
export async function getFirms(search?: string): Promise<Firm[]> {
  const params: Record<string, string> = {};
  if (search) params.search = search;

  const response = await apiClient.get<Firm[]>(`${KB_BASE}/firms`, { params });
  return response.data;
}
